import PropTypes from 'prop-types'
import React from 'react'
import Input from 'components/Form/Input'
import Button from 'components/Button'
import classes from './NewRoute.scss'

import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const NewRoute = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Adding a New Route
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />
      <Input label='Region' placeholder='eg. North Bay' {...props.fields.region} />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Create Route
      </Button>
    </footer>
  </form>
)

NewRoute.propTypes = {
  route: PropTypes.object.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default NewRoute



// WEBPACK FOOTER //
// ./src/components/Routes/New/NewRoute.js